export const FONT_CLASSNAMES = {
  sans: 'font-sans',
  archivo: 'font-[Archivo,sans-serif]',
  source: 'font-[Source_Sans_Pro,sans-serif]',
  poppins: 'font-[Poppins,sans-serif]',
  lato: 'font-[Lato,sans-serif]',
  roboto: 'font-[Roboto,sans-serif]',
}
